// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AccordionController from '@kanety/stimulus-accordion';
application.register('accordion', AccordionController);

import NestedFormController from "./nestedFormController";
application.register('nested-form', NestedFormController)

import SortableController from "./sortableController";
application.register('sortable', SortableController)

import TomSelectController from './tomSelectController'
application.register('tom-select', TomSelectController)
